import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../appstate.model';
import { Configuration } from '../configuration/Configuration';
import { Enterprise } from './Enterprise';
import { AuthService } from '../../authentication/_services/auth.service';

@Injectable()
export class EnterpriseService {
  config: Configuration;
  private cache: { [key: string]: Observable<Enterprise[]> } = {};

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private authService: AuthService
  ) {
    this.store
      .select((x) => x.Configuration)
      .subscribe((x) => {
        this.config = x;
      });
  }

  search(searchString: string): Observable<Enterprise[]> {
    if (!this.cache[searchString]) {
      const headers = new HttpHeaders({
        UserName: this.authService.loggedAppUser.appUserName
      });

      this.cache[searchString] = this.http
        .get<
          Enterprise[]
        >(`${this.config.shipmentServiceUrl}enterprise/search?searchString=${searchString}`, { headers: headers })
        .pipe(
          // Cache for 5 minutes (300000ms)
          shareReplay({ bufferSize: 1, refCount: true, windowTime: 300000 })
        );
    }

    return this.cache[searchString];
  }
}
